import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import React from 'react';
import {
  TabsAlignment as ALIGNMENT,
  TabsSkin as SKIN,
  Tabs,
  TabsVariant as VARIANT,
} from 'wix-ui-tpa/cssVars';
import { AlignmentOptions } from '../../../../../../types/types';
import settingsParams from '../../../../settingsParams';
import { useWidgetActions } from '../../../hooks/useWidgetActions';
import { useWidgetViewModel } from '../../../hooks/useWidgetViewModel';
import { DataHooks } from '../consts';
import { classes, st } from './TabsFilter.st.css';

const mapAlignmentOptionsToTabsAlignment = {
  [AlignmentOptions.CENTER]: ALIGNMENT.center,
  [AlignmentOptions.LEFT]: ALIGNMENT.left,
  [AlignmentOptions.RIGHT]: ALIGNMENT.right,
};

export default function TabsFilter() {
  const settings = useSettings();
  const { filterOptions } = useWidgetViewModel();
  const { onFilterOptionSelected } = useWidgetActions();
  const { isMobile } = useEnvironment();

  const alignment = settings.get(settingsParams.listFilterAlignment) as AlignmentOptions;
  const variant = settings.get(settingsParams.isListFilterStretched)
    ? VARIANT.fullWidth
    : VARIANT.fit;
  const activeTabIndex = filterOptions.findIndex(
    ({ isSelected }) => isSelected,
  );

  return (
    <Tabs
      data-hook={DataHooks.Tabs}
      className={st(classes.root, { isMobile })}
      skin={SKIN.fitUnderline}
      alignment={mapAlignmentOptionsToTabsAlignment[alignment]}
      variant={variant}
      activeTabIndex={activeTabIndex}
      onTabClick={(selectedTabIndex) => {
        onFilterOptionSelected(filterOptions[selectedTabIndex]);
      }}
      items={filterOptions}
    />
  );
}
